import { hasValue } from '..';
import { RecordType } from '../../..';
import { RecordPropertyForDisplay } from '../RecordProperty';

export const useIngestSourceFields = (
  metadata: RecordType,
  showEmpty: boolean
) => {
  const fields: RecordPropertyForDisplay[] = [
    hasValue(metadata.metadata_sourceCategory)
      ? {
          name: 'metadata_sourceCategory',
          label: 'Source Category',
          value: metadata.metadata_sourceCategory,
        }
      : {
          name: 'metadata_sensorId',
          label: 'Sensor ID',
          value: metadata.metadata_sensorId,
        },
    {
      name: 'metadata_sensorZone',
      label: 'Sensor Zone',
      value: metadata.metadata_sensorZone,
    },
  ];

  if (showEmpty) {
    return fields;
  }

  return fields.filter(({ value }) => hasValue(value));
};
